import Navbar from './modules/navbar'
import Login from './modules/login'
import Signup from './modules/signup';
import AllNotes from './modules/allNotes'
import CreateNote from './modules/createNote';
import HomePage from './modules/homePage';
import Error from './modules/error';
import { ToastContainer, toast } from 'react-toastify';
import {
    Switch,
    Route,
    useHistory
} from "react-router-dom"
import useToken from './helper/useToken';
import 'bulma/css/bulma.min.css'
import 'bulma-pageloader'
import 'bulma-calendar'
import 'react-toastify/dist/ReactToastify.css';
require('dotenv').config()

function App() {
  const history = useHistory();
  const {setToken,token,isLoggedIn,deleteToken} = useToken()
  const showToast = (type,message,statusCode) =>{
    if(type === 'success'){
      toast.success(message, {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        })
      return
    }
    if(type === 'error'){
      toast.error(message, {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        })
        return
    }
  }
  return (
    <div> 
      <Navbar token={token} isLoggedIn={isLoggedIn} logout={deleteToken}/>
      <ToastContainer position="top-center" autoClose={2500} hideProgressBar={false} 
                      newestOnTop={false} closeOnClick rtl={false} 
                      pauseOnFocusLoss draggable pauseOnHover/>
      <Switch>
        <Route exact path="/" >
          <HomePage isLoggedIn={isLoggedIn}/>
        </Route>
        <Route exact path="/login" >
          <Login isLoggedIn={isLoggedIn} setToken={setToken} 
                  showToast={showToast} logout={deleteToken} 
                  history={history} />
        </Route>
        <Route exact path="/signup">
          <Signup isLoggedIn={isLoggedIn} showToast={showToast} history={history}/>
        </Route>
        <Route exact path="/notes" >
            <AllNotes isLoggedIn={isLoggedIn} token={token} 
                      history={history} logout={deleteToken} 
                      showToast={showToast} />
        </Route>
        <Route exact path="/createnote" >
            <CreateNote token={token} isLoggedIn={isLoggedIn} isEditMode={true} 
                        isCreateMode={true} logout={deleteToken} showToast={showToast}/>
        </Route>
        <Route exact path="/viewnote/:id" render={(props)=>{
                return <CreateNote token={token} isLoggedIn={isLoggedIn} isEditMode={false} 
                                  isCreateMode={false} id={props.match.params.id} 
                                  logout={deleteToken} showToast={showToast}/>
        }}/>
        <Route exact path="/editnote/:id" render={(props)=>{
                return <CreateNote token={token} isLoggedIn={isLoggedIn} isEditMode={true} 
                                  isCreateMode={false} id={props.match.params.id} 
                                  logout={deleteToken} showToast={showToast}/>
        }}/>
        <Route render={(props)=>{
            return <Error path={props.location.pathname}/>
        }}/> 
        </Switch>
    </div>
  );
}

export default App;
